import {
   styled
  ,Box
  ,TextareaAutosize 
} from 'external/material'

import useTranslations from 'hooks/translations'
import useAssessment from 'hooks/assessment'

const OpenQuestionContainer = styled(Box)(openQuestionStyles)

export default function OpenQuestion ({question}) {

  const {translate} = useTranslations()
  const {assessment, save} = useAssessment()

  const answer = assessment.answers[question.id]

  function handleChange (e) {
    const value = e.target.value
    const completed = value.length > 0
    save({[question.id]: {$shallow: {value, completed}}}, {sendToServer: false})
  }

  function handleBlur () {
    save({})
  }

  return (
    <OpenQuestionContainer className="root">
      <TextareaAutosize
        className="textarea"
        minRows={5}
        value={answer.value}
        onKeyPress = {({key}) => {
          key == 'Enter' && handleBlur()
        }}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </OpenQuestionContainer>
  )
}

function openQuestionStyles () {
  return {
    "&.root": {
      flexGrow: 1,
      display: 'flex',
      paddingBottom: 20,
      flexDirection: 'column',
    },
    "& .textarea": {
      resize: 'none',
      width: 'auto',
      padding: 8,
      display: 'flex',
      flexGrow: 1,
      borderRadius: '4px',
      border: 'solid 1px #c2c7ca',
    },
  }
}
